import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { frontendserverurl, serverurl } from '../../environments/environment';
import { SnackService } from './snack.service';

@Injectable({
  providedIn: 'root'
})
export class CustomRegisterFormService {
    public defaultConfig: unknown[] = [];

    private http = inject(HttpClient);
    private snackService = inject(SnackService);

    public async getDefaultConfig(): Promise<boolean> {
        if (this.defaultConfig.length) {
            return true;
        }

        return await new Promise((resolve) =>
            this.http.get<unknown[]>(`
                ${frontendserverurl}/public/data/custom-login-form.json`,
            )
                .subscribe({
                    next: (data: unknown[]) => {
                        this.defaultConfig = data;
                        resolve(true);
                    },
                    error: (error) => {
                        this.snackService.error(error)
                        resolve(false);
                    },
                }),
        );
    }

    public async saveRegisterFormToInvite(
        inviteLinkId: string,
        form: unknown[],
    ): Promise<boolean> {
        return await new Promise((resolve) =>
            this.http.post(
                `${serverurl}/companies/invite/${inviteLinkId}/register-form`,
                { form }
            )
                .subscribe({
                    next: () => {
                        this.snackService.success({ headline: "Register Form Saved", text: "The register form has successfully been added to the invite link." });
                        resolve(true);
                    },
                    error: (err) => {
                        this.snackService.error(err);
                        resolve(false);
                    },
                }),
        );
    }

    public async removeRegisterFormFromInvite(inviteLinkId: string): Promise<boolean> {
        return await new Promise((resolve) =>
            this.http.delete(serverurl + `/companies/invite/${inviteLinkId}/register-form`)
                .subscribe({
                    next: () => {
                        this.snackService.success({ headline: "Register Form Removed", text: "The register form has successfully been removed from the invite link." });
                        resolve(true);
                    },
                    error: (err) => {
                        this.snackService.error(err);
                        resolve(false);
                    },
                }),
        );
    }
}
